import React from 'react';
import './CalendarComponent.css'; 

const CalendarComponent = ({ provideravailabledays }) => {

    //   const availableDays = provideravailabledays ||[];

    const availableDays = (provideravailabledays || []).sort((a, b) => {
        const dayOrder = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const todayIndex = new Date().getDay(); // 0 (Sun) to 6 (Sat)
        const reorderedDayOrder = [
            ...dayOrder.slice(todayIndex),
            ...dayOrder.slice(0, todayIndex)
        ];
        return reorderedDayOrder.indexOf(a.day) - reorderedDayOrder.indexOf(b.day);
    });
    
    

    return (
        <div className="pvCalContainerSm">
            {availableDays && (
                <div className="pvCalBox">
                    <div className="pvCalHeader">
                        <h5 className="pvCalTitle">Available Days & Time</h5>
                        <p className="pvCalSubtitle">Weekly overview</p>
                    </div>

                    <div className="pvScheduleGridSm">
                        {availableDays.map((day) => (
                            <div
                                className="pvScheduleCardSm"
                                key={day._id}
                            >
                                <div className="pvDayHeader">
                                    <div className="pvDotSm" />
                                    <span className="pvDayTitle">{day.day}</span>
                                </div>
                                <div className="pvTimeSlotListSm">
                                    {day.shifts.map((shift) => (
                                        <div className="pvTimeSlotSm" key={shift._id}>
                                            {shift.startTime} - {shift.endTime}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default CalendarComponent;
